module.exports = __webpack_public_path__ + "static/media/order_date.08d4a668.svg";